import styled from 'styled-components';

export const StyledText = styled('span')`
  border-bottom: 1px dotted ${({ theme }) => theme.color.brand01};
  background-color: ${({ theme }) => theme.color.brand01RGBA(0.1)};
  cursor: helper;
`;
